// extracted by mini-css-extract-plugin
export default {"resizeHandle":"AppShell-module__resizeHandle__OBDqE","resizeHandleActive":"AppShell-module__resizeHandleActive__OQBYy","navWrapper":"AppShell-module__navWrapper__hFDKu"};